<template>
  <div>
    <div class="header-text">
      <h1>404</h1>
      <h3>OOPS! Something went wrong here</h3>
    </div>
    <img src="../assets/bg1.jpg" />
  </div>
</template>

<script>
export default {
  name: "NotFound",
};
</script>

<style>
img {
  width: auto;
  height: 100vh;
}
.header-text {
  margin-top: 100px;
  margin-left: 50px;
  position: fixed;
}
.header-text h1 {
  font-size: 10rem;
}
.header-text h3 {
  font-size: 1.5rem;
}
</style>
